const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div id="article-listing">
  <div class="o-container o-container--pad">
    <div class="o-container__content">
      `);
                this.echo(this.include(context, this.source, this.loadTemplate(`1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, 4, 78), new Map([[`class`, `o-deck--3-column@l`]]), true, false, 4));
                this.echo(`      `);
                this.echo(this.include(context, this.source, `@cloudfour/components/pagination/pagination.twig`, new Map([[`pagination`, new Map([[`mid_size`, 2], [`current`, 1], [`total`, 36], [`prev`, new Map([[`title`, 1], [`text`, 1], [`name`, 1], [`current`, false], [`link`, `#page-1`]])], [`next`, new Map([[`title`, 3], [`text`, 3], [`name`, 3], [`current`, false], [`link`, `#page-3`]])], [`pages`, new Map([[0, new Map([[`title`, 1], [`text`, 1], [`name`, 1], [`current`, false], [`link`, `#page-1`]])], [1, new Map([[`title`, 2], [`text`, 2], [`name`, 2], [`current`, true], [`link`, false]])], [2, new Map([[`title`, 3], [`text`, 3], [`name`, 3], [`current`, false], [`link`, `#page-3`]])], [3, new Map([[`title`, 4], [`text`, 4], [`name`, 4], [`current`, false], [`link`, `#page-4`]])], [4, new Map([[`title`, 5], [`text`, 5], [`name`, 5], [`current`, false], [`link`, `#page-5`]])]])]])]]), false, false, 48));
                this.echo(`    </div>
  </div>
  `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.traceableMethod(this.getAttribute, 108, this.source)(this.env, (context.has(`featured`) ? context.get(`featured`) : null), `topics`, new Map([]), `any`, false, false, false));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`topic`] = __value__;
                    this.echo(`    <div class="o-container o-container--pad">
      <div class="o-container__content">
        <div class="section">
            <div class="section-title-wrapper">
              `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`,  -1], [`tag_name`, `h2`], [`weight`, `light`], [`content`, this.traceableMethod(this.getAttribute, 117, this.source)(this.env, context.get(`topic`), `title`, new Map([]), `any`, false, false, false)]]), false, false, 113));
                    this.echo(`            </div>
            `);
                    context.set('_parent', context.clone());

                    (() => {
                        let c = this.ensureTraversable(this.traceableMethod(this.getAttribute, 120, this.source)(this.env, context.get(`topic`), `articles`, new Map([]), `any`, false, false, false));

                        if (c === context) {
                            context.set('_seq', context.clone());
                        }
                        else {
                            context.set('_seq', c);
                        }
                    })();

                    context.set('loop', new Map([
                      ['parent', context.get('_parent')],
                      ['index0', 0],
                      ['index', 1],
                      ['first', true]
                    ]));
                    if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                        let length = this.count(context.get('_seq'));
                        let loop = context.get('loop');
                        loop.set('revindex0', length - 1);
                        loop.set('revindex', length);
                        loop.set('length', length);
                        loop.set('last', (length === 1));
                    }
                    this.iterate(context.get('_seq'), (__key__, __value__) => {
                        context.proxy[`_key`] = __key__;
                        context.proxy[`article`] = __value__;
                        this.echo(`              <div class="section-card-wrapper">
                `);
                        this.echo(this.include(context, this.source, this.loadTemplate(`1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, 122, 79), new Map([[`class`, ``], [`href`, this.traceableMethod(this.getAttribute, 124, this.source)(this.env, context.get(`article`), `link`, new Map([]), `any`, false, false, false)]]), true, false, 122));
                        this.echo(`              </div>
            `);
                        (() => {
                            let loop = context.get('loop');
                            loop.set('index0', loop.get('index0') + 1);
                            loop.set('index', loop.get('index') + 1);
                            loop.set('first', false);
                            if (loop.has('length')) {
                                loop.set('revindex0', loop.get('revindex0') - 1);
                                loop.set('revindex', loop.get('revindex') - 1);
                                loop.set('last', loop.get('revindex0') === 0);
                            }
                        })();
                    });
                    (() => {
                        let parent = context.get('_parent');
                        context.delete('_seq');
                        context.delete('_iterated');
                        context.delete('_key');
                        context.delete('article');
                        context.delete('_parent');
                        context.delete('loop');
                        for (let [k, v] of parent) {
                            if (!context.has(k)) {
                                context.set(k, v);
                            }
                        }
                    })();
                    this.echo(`            <div class="section-cta-wrapper">
              `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, 156, 80), new Map([[`class`, `c-button--secondary`]]), true, false, 156));
                    this.echo(`            </div>
          </div>
      </div>
    </div>
  `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('topic');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`  <div class="o-container o-container--pad">
    <div class="o-container__content">
      `);
                this.echo(this.include(context, this.source, this.loadTemplate(`1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, 171, 83), new Map([[`labelledby_id`, `more-topics`]]), true, false, 171));
                this.echo(`    </div>
  </div>
</div>
`);
            }

            getTemplateName() {
                return `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, ``);
            }
        }],
        [78, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/deck/deck.twig`, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, 4);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/deck/deck.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.traceableMethod(this.getAttribute, 8, this.source)(this.env, (context.has(`recent`) ? context.get(`recent`) : null), `articles`, new Map([]), `any`, false, false, false));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`article`] = __value__;
                    this.echo(`            `);
                    if (this.compare(this.traceableMethod(this.getAttribute, 9, this.source)(this.env, context.get(`loop`), `index`, new Map([]), `any`, false, false, false), `1`)) {
                        this.echo(`              `);
                        context.proxy[`_card_class`] = `c-card--horizontal@l`;
                        this.echo(`            `);
                    }
                    else {
                        this.echo(`              `);
                        context.proxy[`_card_class`] = ``;
                        this.echo(`            `);
                    }
                    this.echo(`            `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, 14, 77), new Map([[`class`, (context.has(`_card_class`) ? context.get(`_card_class`) : null)], [`href`, this.traceableMethod(this.getAttribute, 16, this.source)(this.env, context.get(`article`), `link`, new Map([]), `any`, false, false, false)]]), true, false, 14));
                    this.echo(`          `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('article');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`        `);
            }

            getTemplateName() {
                return `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, ``);
            }
        }],
        [77, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/card/card.twig`, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, 14);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['cover', [this, 'block_cover']],
                    ['content', [this, 'block_content']],
                    ['footer', [this, 'block_footer']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/card/card.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                `);
                this.echo(this.env.getFilter('escape').traceableCallable(19, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 19, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`
              `);
            }

            block_cover(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                <img src="`);
                this.echo(this.env.getFilter('escape').traceableCallable(22, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 22, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `thumbnail`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`" alt="">
              `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                <p>
                  `);
                if ((this.env.getFilter('length').traceableCallable(26, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 26, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `description`, new Map([]), `any`, false, false, false)]) > 140)) {
                    this.echo(`                    `);
                    this.echo(this.env.getFilter('escape').traceableCallable(27, this.source)(...[this.env, this.env.getFilter('trim').traceableCallable(27, this.source)(...[this.env.getFilter('slice').traceableCallable(27, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 27, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `description`, new Map([]), `any`, false, false, false), 0, 140])]), `html`, null, true]));
                    this.echo(`…
                  `);
                }
                else {
                    this.echo(`                    `);
                    this.echo(this.env.getFilter('escape').traceableCallable(29, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 29, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `description`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`
                  `);
                }
                this.echo(`                </p>
              `);
            }

            block_footer(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                <div class="c-author o-media">
                  <div class="o-media__object">
                    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`src`, this.traceableMethod(this.getAttribute, 36, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `avatar`, new Map([]), `any`, false, false, false)]]), false, false, 36));
                this.echo(`                  </div>
                  <div class="o-media__content">
                    <p<a href="#">`);
                this.echo(this.env.getFilter('escape').traceableCallable(39, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 39, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `author`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`</a></p>
                    <p>`);
                this.echo(this.env.getFilter('escape').traceableCallable(40, this.source)(...[this.env, this.env.getFilter('date').traceableCallable(40, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 40, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `pubDate`, new Map([]), `any`, false, false, false), `M j, Y`]), `html`, null, true]));
                this.echo(`</p>
                  </div>
                </div>
              `);
            }

            getTemplateName() {
                return `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, ``);
            }
        }],
        [79, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/card/card.twig`, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, 122);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['cover', [this, 'block_cover']],
                    ['content', [this, 'block_content']],
                    ['footer', [this, 'block_footer']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/card/card.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    `);
                this.echo(this.env.getFilter('escape').traceableCallable(127, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 127, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`
                  `);
            }

            block_cover(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <img src="`);
                this.echo(this.env.getFilter('escape').traceableCallable(130, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 130, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `thumbnail`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`" alt="">
                  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <p>
                      `);
                if ((this.env.getFilter('length').traceableCallable(134, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 134, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `description`, new Map([]), `any`, false, false, false)]) > 140)) {
                    this.echo(`                        `);
                    this.echo(this.env.getFilter('escape').traceableCallable(135, this.source)(...[this.env, this.env.getFilter('trim').traceableCallable(135, this.source)(...[this.env.getFilter('slice').traceableCallable(135, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 135, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `description`, new Map([]), `any`, false, false, false), 0, 140])]), `html`, null, true]));
                    this.echo(`…
                      `);
                }
                else {
                    this.echo(`                        `);
                    this.echo(this.env.getFilter('escape').traceableCallable(137, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 137, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `description`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`
                      `);
                }
                this.echo(`                    </p>
                  `);
            }

            block_footer(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <div class="c-author o-media">
                      <div class="o-media__object">
                        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`src`, this.traceableMethod(this.getAttribute, 144, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `avatar`, new Map([]), `any`, false, false, false)]]), false, false, 144));
                this.echo(`                      </div>
                      <div class="o-media__content">
                        <p<a href="#">`);
                this.echo(this.env.getFilter('escape').traceableCallable(147, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 147, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `author`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`</a></p>
                        <p>`);
                this.echo(this.env.getFilter('escape').traceableCallable(148, this.source)(...[this.env, this.env.getFilter('date').traceableCallable(148, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 148, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `pubDate`, new Map([]), `any`, false, false, false), `M j, Y`]), `html`, null, true]));
                this.echo(`</p>
                      </div>
                    </div>
                  `);
            }

            getTemplateName() {
                return `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, ``);
            }
        }],
        [80, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/button/button.twig`, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, 156);

                this.blocks = new Map([
                    ['content', [this, 'block_content']],
                    ['content_end', [this, 'block_content_end']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/button/button.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.env.getFilter('escape').traceableCallable(157, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 157, this.source)(this.env, (context.has(`topic`) ? context.get(`topic`) : null), `cta`, new Map([]), `any`, false, false, false), `html`, null, true]));
            }

            block_content_end(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                  `);
                this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, `arrow-right`]]), false, false, 159));
                this.echo(`                `);
            }

            getTemplateName() {
                return `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, ``);
            }
        }],
        [83, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/overview/overview.twig`, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, 171);

                this.blocks = new Map([
                    ['header', [this, 'block_header']],
                    ['actions', [this, 'block_actions']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/overview/overview.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_header(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`,  -1], [`weight`, `light`], [`content`, `More Topics`], [`id`, `more-topics`]]), false, false, 175));
                this.echo(`        `);
            }

            block_actions(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          <div class="search-content">
            `);
                this.echo(this.include(context, this.source, `@cloudfour/components/input/input.twig`, new Map([[`class`, `search-input`]]), true, false, 184));
                this.echo(`            `);
                this.echo(this.include(context, this.source, this.loadTemplate(`1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, 187, 81), new Map([[`class`, `search-btn`]]), true, false, 187));
                this.echo(`          </div>
        `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.echo(this.include(context, this.source, this.loadTemplate(`1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, 200, 82), new Map([[`tag_name`, `ul`], [`class`, `o-list--2-column@m o-list--3-column@l`]]), true, false, 200));
                this.echo(`        `);
            }

            getTemplateName() {
                return `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, ``);
            }
        }],
        [81, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/button/button.twig`, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, 187);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/button/button.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                `);
                this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, `magnifying-glass`], [`inline`, true]]), false, false, 191));
                this.echo(`              `);
            }

            getTemplateName() {
                return `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, ``);
            }
        }],
        [82, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/list/list.twig`, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, 200);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/list/list.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`topics`) ? context.get(`topics`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`topic`] = __value__;
                    this.echo(`                `);
                    this.echo(`                <li class="u-pad-block-end-0">
                  `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/dot-leader/dot-leader.twig`, new Map([[`label`, this.traceableMethod(this.getAttribute, 212, this.source)(this.env, context.get(`topic`), `title`, new Map([]), `any`, false, false, false)], [`count`, this.traceableMethod(this.getAttribute, 213, this.source)(this.env, context.get(`topic`), `count`, new Map([]), `any`, false, false, false)], [`href`, `https://cloudfour.com/thinks/`]]), false, false, 211));
                    this.echo(`                </li>
              `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('topic');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`            `);
            }

            getTemplateName() {
                return `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63');

let template = env.loadTemplate('1723d59610c898a24aa7a1fdc3dd4023b857866d71bb3b33cc8365b52b824c63');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/article-listing/example/example.twig", args: context }
     );
     return rendered;;
};